import {Annotation} from './Annotation'

/**
 * Metadata for a component property that is not a property of the component itself,
 * but is supplied by the form builder.
 */
export class ModuleAnnotation extends Annotation {
}
